import { OrderAssistFacilityOption, SelectOption, WriteBackProvider } from '../types';
import addressFormat from './addressFormatter';
import { getSelectedItemAddress } from './search/getSelectedAddress';

export const parseFacilityToWritebackProvider = (
  option: OrderAssistFacilityOption,
  ehrSpecialty: SelectOption | undefined,
): WriteBackProvider => {
  const { details } = option;
  const address = getSelectedItemAddress(option);
  const specialties = ehrSpecialty
    ? [{ id: ehrSpecialty.value, description: ehrSpecialty.label }]
    : details.specialties ?? [];

  // Facilities don't have demographics (they're not people), but WriteBackProvider type
  // requires it. We cast to satisfy TypeScript since SDK won't use demographics for facilities.
  return {
    npi: details.npi,
    specialty: specialties,
    organizations: [
      {
        name: details.name || details.acoName || address?.officeName || '',
        address: address
          ? {
              ...address,
              fullAddress: addressFormat(address),
            }
          : { zipCode: '' },
        contact_info: {
          mobilePhoneNumber: address?.phone,
          faxNumber: address?.fax,
        },
      },
    ],
  } as unknown as WriteBackProvider;
};
